import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Province = () => {
  const { t, errors, province, showProvince, showAddressFields, customInput, updateAddress, isEditable } = useAddress()

  if (!showProvince || !showAddressFields) {
    return null
  }

  return (
    <FormControl error={getError('province', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.readonly_province')}
        currentValue={province}
        readOnly={!customInput}
        disabled={!customInput || isEditable === false}
        onBlur={customInput ? value => updateAddress({ province: value }) : undefined}
        overrides={undefined}
        status={undefined}
        outerOnchange={undefined}
      />
    </FormControl>
  )
}

export default Province
